export const environment = {
  POST_GAME_URL: 'https://postgame.blueteesgolf.com/',
  BASE_API_PATH: 'https://dev.blueteesgolf.com/exp',
  BASE_IMAGE_PATH: 'https://dpzcn2dwpyv8l.cloudfront.net/bluetees-app',
  BASE_STATIC: 'https://blueteesdb.s3.amazonaws.com/bluetees-app',
  TOKEN_SPLIT: '^8luetee5^',
  TOKEN_SECRET: 'hB5i0&BhmWOojpgszvB@yIaENLI0&ZR0HdRX0ZYZAYMB&',
  TOKEN_KEY: 'MyAwesomeWE85kitterKey',
  TOKEN_KEY_SECRET: `knR@hyZ9DGzOAZfHV8wv$RxaeivSGifQTLimbuaV`,
  AUTH_SECRET_KEY: `R&y57*U*kf1Q6+8web+BGn8Xp7%qHkb%A6L$gv2&xnQ!7mjKDXeG`,
  SOCKET_PATH: 'https://dev.blueteesgolf.com',
  GOOGLE_CAPTCHA_KEY: '6Ldq5RUpAAAAANHT2dnTqU3_YZNtv1Crk2nSLnaB',
  IGOLF_BASE_PATH: 'https://api-connect-blue.igolf.com',
  CloudflareRecaptchaSiteKey: '0x4AAAAAACNckH8zwgkcGmrD', // Staging: 0x4AAAAAAA4PQ4W9-uNKIZnN, Pre-prod: 0x4AAAAAAA4PQlRFNnuZ3_Ag, Live: 0x4AAAAAAA4FizZ9zCi2xmwE
  IGOLF: {
    API_KEY: 'UCCBMXN9wK1-Voc',
    SECRET_KEY: 'bqbGf6WQuRr7yx2a3Snyth64C9miIA',
    API_VERSION: '1.1',
    SIG_VERSION: '2.0',
    SIG_METHOD: 'HmacSHA256',
    RESPONSE_FORMAT: 'JSON',
  },
  SITE_URL: 'https://pregame.blueteesgolf.com',
  MAPBOX_ACCESSTOKEN: 'pk.eyJ1IjoiYmx1ZXQxIiwiYSI6ImNseDljZHF4ejFhODEya3BtNGR4em5xcWsifQ.E1SFkLHNQt1JeCOwrZGsWA',
  MAPBOX_ACCESSTOKEN_SECRET: 'sk.eyJ1IjoiYmx1ZXQxIiwiYSI6ImNtZGg4YWM0bDAwanYybHF1M2dsYmYxdzkifQ.SZs5P8ZsQmHgTJ_XsX6HsA',
  MAPBOX_STYLE: 'bluet1/cm66cf9yb003501s7akmn42za',
  defaultRegionUrl: `/bestcourse/north-america/united-states-of-america`
};
